import type { FunctionComponent, PropsWithChildren } from 'react';

import Link from './Link';
import type { LinkProps } from './Link';

export const DOCS_HOME_URL = 'https://docs.fossa.com';
export const DOCS_URL = `${DOCS_HOME_URL}/docs`;

/**
 * Check if a string begins with "/"
 */
const startsWithSlash = (str = '') => str.charAt(0) === '/';

/**
 * Check if a string points at the docs root (empty or just "/")
 */
const isDocsRoot = (str = '') => str === '' || str === '/';

/**
 * Construct the docs URL. The root links to the docs home; everything else
 * lives under the "/docs" path.
 */
export const getDocsUrl = (to = '') => (isDocsRoot(to)
  ? DOCS_HOME_URL
  : `${DOCS_URL}${startsWithSlash(to) ? '' : '/'}${to}`);

const defaultProps: PropsWithChildren<LinkProps> = {
  to: '',
  children: null,
  openInNewTab: true,
};

/**
 * A <Link /> with "https://docs.fossa.com/docs" prefixed to the "to" prop
 */
const DocsLink: FunctionComponent<LinkProps> = ({ to, ...props } = defaultProps) => (
  <Link
    {...props}
    to={getDocsUrl(to)}
    openInNewTab
  />
);

export default DocsLink;
